import { useState, useEffect, useCallback } from 'react';
import {
  getHeadersUnwrapped,
  useUserContext,
  IApiCallStatus,
  IError,
} from '../common';
import { IStatusLegacies, searchLegacyStatus } from '.';
import { fold } from 'fp-ts/lib/Either';
import { flow } from 'fp-ts/function';

export const useLegacyRequestSearch = ({
  page,
  pageSize,
}: {
  page: number;
  pageSize: number;
}) => {
  const { user } = useUserContext();
  const [requestStatus, setRequestStatus] = useState<IStatusLegacies>({
    total: 0,
    content: [],
  });

  const [call, setCall] = useState<IApiCallStatus>();

  useEffect(() => {
    call === null &&
      flow(
        getHeadersUnwrapped,

        searchLegacyStatus
      )(user)({
        page,
        pageSize,
      }).then(
        fold<IError, IStatusLegacies, void>(
          flow(
            e =>
              setRequestStatus({
                total: 0,
                content: [],
              }),
            () => setCall(false)
          ),
          flow(setRequestStatus, () => setCall(true))
        )
      );
  }, [user, page, pageSize, call]);

  const search = useCallback(() => setCall(null), []);
  return { requestStatus, call, search };
};
